import { useParams } from 'react-router-dom';

import { useGetCollectionsQuery, GetCollectionsQueryHookResult } from 'types/graphql';
import { useStores } from 'src/hooks/use-stores';

type UseGetCollectionsReturn = {
  collections: NonNullable<NonNullable<GetCollectionsQueryHookResult['data']>['getCollections']>;
  loading: GetCollectionsQueryHookResult['loading'];
};

export function useGetCollections(): UseGetCollectionsReturn {
  const { id: dispensaryId } = useParams<{ id: string }>();
  const { apolloClient } = useStores();

  const { data, loading } = useGetCollectionsQuery({
    variables: { dispensaryId, customCategory: false },
    client: apolloClient,
  });

  return { collections: data?.getCollections ?? [], loading };
}
